<template>
  <g>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.10156 8C4.10156 8.82843 3.42999 9.5 2.60156 9.5C1.77314 9.5 1.10156 8.82843 1.10156 8C1.10156 7.17157 1.77314 6.5 2.60156 6.5C3.42999 6.5 4.10156 7.17157 4.10156 8ZM9.50098 8C9.50098 8.82843 8.8294 9.5 8.00098 9.5C7.17255 9.5 6.50098 8.82843 6.50098 8C6.50098 7.17157 7.17255 6.5 8.00098 6.5C8.8294 6.5 9.50098 7.17157 9.50098 8ZM13.4014 9.5C14.2298 9.5 14.9014 8.82843 14.9014 8C14.9014 7.17157 14.2298 6.5 13.4014 6.5C12.5729 6.5 11.9014 7.17157 11.9014 8C11.9014 8.82843 12.5729 9.5 13.4014 9.5Z"
      :fill="fill"
    />
  </g>
</template>

<script>
export default {
  props: {
    fill: {
      type: String,
      required: true
    }
  }
};
</script>
